import { render } from "./dokterRSUD.vue?vue&type=template&id=5f55a7f6"
import script from "./dokterRSUD.vue?vue&type=script&lang=js"
export * from "./dokterRSUD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__